import {APICore} from "./apiCore";
import {AUTH_LIMIT} from "./authLimit";

// Sign-in steps reject with an AuthLimitError when rate limited (see authLimit.ts).
const limited = { [AUTH_LIMIT]: true };

const api = new APICore();

// account
function login(params: { email: string; password: string }) {
    const baseUrl = "/supplier-api/auth/login";
    return api.create(`${baseUrl}`, params, limited);
}

function refreshToken(params: { refresh_token: string }) {
    const baseUrl = "/supplier-api/auth/refresh-token";
    return api.create(`${baseUrl}`, params);
}

function logout() {
    const baseUrl = "/supplier-api/auth/logout";
    return api.create(`${baseUrl}`, {});
}

function forgotPassword(params: { email: string }) {
    const baseUrl = "/supplier-api/auth/forgot_password";
    return api.create(`${baseUrl}`, params);
}

function resetPassword(params: { token: string, password: string, password_confirmation: string }) {
    const baseUrl = "/supplier-api/auth/reset-password/verify";
    return api.create(`${baseUrl}`, params, limited);
}

// ── MFA ──────────────────────────────────────────────────────────────────────
// Second step of login: exchange a verified code for the full session.
function mfaVerify(params: { challengeToken: string; code: string }) {
    return api.create("/supplier-api/auth/mfa/verify", params, limited);
}
function mfaResend(params: { challengeToken: string }) {
    return api.create("/supplier-api/auth/mfa/resend", params, limited);
}
// Settings → Security (authenticated session).
function mfaStatus() {
    return api.get("/supplier-api/auth/mfa/status", {});
}
function mfaEnrollStart() {
    return api.create("/supplier-api/auth/mfa/enroll/start", {});
}
function mfaEnrollConfirm(params: { challengeToken: string; code: string }) {
    return api.create("/supplier-api/auth/mfa/enroll/confirm", params);
}
function mfaDisable(params: { code: string }) {
    return api.create("/supplier-api/auth/mfa/disable", params);
}
function mfaRegenerateBackupCodes(params: { code: string }) {
    return api.create("/supplier-api/auth/mfa/backup-codes/regenerate", params);
}

export {
    login, refreshToken, logout, forgotPassword, resetPassword,
    mfaVerify, mfaResend, mfaStatus, mfaEnrollStart, mfaEnrollConfirm, mfaDisable, mfaRegenerateBackupCodes,
};
